import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { NgbPanelChangeEvent } from '@ng-bootstrap/ng-bootstrap';
import { FileSaverService } from 'ngx-filesaver';
import { NgxSpinnerService } from 'ngx-spinner';
import { firstValueFrom, of, Subscription, switchMap, tap } from 'rxjs';
import {
  paymentsApi,
  usersManageApi,
} from 'src/app/shared/constants/api.constants';
import { UserService } from '../user.service';
import { HelpersService, HttpBaseService }   from '@evento-ng/libs';

@Component({
  selector: 'app-my-weapons',
  templateUrl: './my-tickets.component.html',
  styleUrls: ['./my-tickets.component.scss'],
})
export class MyTicketsComponent implements OnInit, OnDestroy {
  invoices = {
    data: Array(10),
    meta: null,
  };
  selectedInvoiceTickets: any[];
  page = 1;
  subs: Subscription[] = [];

  constructor(
    private dataService: HttpBaseService,
    private router: Router,
    private userService: UserService,
    private spinner: NgxSpinnerService,
    public helpers: HelpersService,
    private fileSaverService: FileSaverService
  ) {}

  ngOnInit(): void {
    this.getInvoices();
  }

  getInvoices(): void {
    this.subs.push(
      this.userService.selectedUser$
        .pipe(
          switchMap((user) => {
            if (user) {
              return this.dataService
                .get(`${usersManageApi}/tickets/${user.id}`, {
                  params: {
                    page: this.page,
                  },
                })
                .pipe(
                  tap((res) => {
                    this.spinner.hide();
                    this.invoices = res;
                  })
                );
            }
            return of({
              data: Array(10),
              meta: null,
            });
          })
        )
        .subscribe()
    );
  }

  getTickets(ev: NgbPanelChangeEvent): void {
    firstValueFrom(
      this.dataService.get(`${paymentsApi}/${ev.panelId}`).pipe(
        tap((res) => {
          this.selectedInvoiceTickets = res.orders;
        })
      )
    );
  }

  downloadInvoice(invoiceId: string): void {
    window.open(window.origin + '/html-design/' + invoiceId, '_blank');
    // this.spinner.show();
    // firstValueFrom(
    //   this.dataService
    //     .get(`${publicPaymentsApi}/${invoiceId}/download`, {
    //       headers: new HttpHeaders({
    //         'Content-Type': 'application/pdf',
    //       }),
    //       responseType: 'blob' as 'json',
    //     })
    //     .pipe(
    //       tap((res) => {
    //         this.fileSaverService.save(res, `${invoiceId}.pdf`);
    //         this.spinner.hide();
    //       })
    //     )
    // );
  }

  downloadTicket(ticketId: string): void {
    // this.spinner.show();
    // firstValueFrom(
    //   this.dataService
    //     .get(`${ordersApi}/${ticketId}/download`, {
    //       headers: new HttpHeaders({
    //         'Content-Type': 'application/pdf',
    //       }),
    //       responseType: 'blob' as 'json',
    //     })
    //     .pipe(
    //       tap((res) => {
    //         this.fileSaverService.save(res, `${ticketId}.pdf`);
    //         this.spinner.hide();
    //       })
    //     )
    // );
  }

  goToPage(n: number): void {
    this.page = n;
    this.spinner.show();
    this.getInvoices();
  }

  onNext(): void {
    this.page++;
    this.spinner.show();
    this.getInvoices();
  }

  onPrev(): void {
    this.page--;
    this.spinner.show();
    this.getInvoices();
  }

  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }
}
